// extracted by mini-css-extract-plugin
export default {"container":"CategoryDisplayMobile_container__MLGLg","wrap":"CategoryDisplayMobile_wrap__1rHdY"};